import React from 'react';
import { FaAndroid, FaApple } from 'react-icons/fa';
import { Capacitor } from '@capacitor/core';
import collegeConfig from '../../config/collegeConfig';
import './AppDownloadBanner.css';

// Never show the banner inside a Capacitor native app
const isNativePlatform = Capacitor.isNativePlatform();

const AppDownloadBanner = () => {
  if (isNativePlatform) return null;

  const androidLink = collegeConfig.appLinks?.android || null;
  const iosLink     = collegeConfig.appLinks?.ios     || null;

  const handleAndroid = () => {
    if (androidLink) window.open(androidLink, '_blank', 'noopener,noreferrer');
  };

  const handleIOS = () => {
    if (iosLink) window.open(iosLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="app-download-banner">
      <p className="app-download-label">Get the App</p>
      <div className="app-download-buttons">
        <button
          className={`app-dl-btn app-dl-btn-android${!androidLink ? ' app-dl-btn-soon' : ''}`}
          onClick={handleAndroid}
          disabled={!androidLink}
          title={androidLink ? 'Open on Google Play' : 'Coming Soon'}
        >
          <FaAndroid size={18} />
          <span>
            <span className="app-dl-sub">Get it on</span>
            <span className="app-dl-main">{androidLink ? 'Google Play' : 'Coming Soon'}</span>
          </span>
        </button>

        <button
          className={`app-dl-btn app-dl-btn-ios${!iosLink ? ' app-dl-btn-soon' : ''}`}
          onClick={handleIOS}
          disabled={!iosLink}
          title={iosLink ? 'Download on App Store' : 'Coming Soon'}
        >
          <FaApple size={18} />
          <span>
            <span className="app-dl-sub">Download on the</span>
            <span className="app-dl-main">{iosLink ? 'App Store' : 'Coming Soon'}</span>
          </span>
        </button>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
